import { z } from 'zod';

export const claudeCredentialTypeSchema = z.enum(['oauth_token', 'api_key']);
export type ClaudeCredentialType = z.infer<typeof claudeCredentialTypeSchema>;

/**
 * Write-only secret: this shape is what the API returns, and it never
 * includes the secret value — see docs/superpowers/specs/2026-08-11-claude-credentials-admin-design.md
 * decision 4.
 */
export const claudeCredentialSchema = z.object({
  id: z.string().uuid(),
  alias: z.string().min(1).max(200),
  type: claudeCredentialTypeSchema,
  createdAt: z.string().datetime(),
  lastValidatedAt: z.string().datetime().nullable(),
  isActive: z.boolean(),
});
export type ClaudeCredential = z.infer<typeof claudeCredentialSchema>;

/** `POST /admin/claude-credentials` body. Validated against the real `claude` CLI before it's ever persisted. */
export const createClaudeCredentialInputSchema = z.object({
  alias: z.string().min(1).max(200),
  type: claudeCredentialTypeSchema,
  secret: z.string().min(1).max(10_000),
});
export type CreateClaudeCredentialInput = z.infer<typeof createClaudeCredentialInputSchema>;
